import times from 'lodash/times';
import React from 'react';
import { RealizedGainLossDetailsSkeleton } from './RealizedGainLossDetailsSkeleton';
import { TableCell, TableRow } from '../../../../../../../CommonComponents/OPL/Table/Table';
import { Shimmer } from '../../../../../../../CommonComponents/OPL/Shimmer/Shimmer';

interface Props {
  title: string;
}

export const RealizedGainLossDetailsLoading = ({ title }: Props) => {
  return (
    <RealizedGainLossDetailsSkeleton title={title}>
      {times(7).map(i => (
        <TableRow key={i}>
          <TableCell width="40%">
            <Shimmer width="100%" height={20} />
          </TableCell>

          {times(11).map(j => (
            <TableCell key={j} width="10%">
              <Shimmer width="100%" height={20} />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </RealizedGainLossDetailsSkeleton>
  );
};
